import script from "./GradeCell.vue?vue&type=script&setup=true&lang=js"
export * from "./GradeCell.vue?vue&type=script&setup=true&lang=js"

import "./GradeCell.vue?vue&type=style&index=0&id=0a7ae1a4&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a7ae1a4"]])

export default __exports__